import React from 'react'
import dogeEnvironmentIcon from '../../../../assets/images/doge_environment__icon.png';
import SubHeading from '../../../ui/SubHeading';

const DogeEnvironment = () => {
  return ( 
    <>
      <div className="specialty__card flex-col m-6 mb-12 md:ml-12 md:m-2 md:w-5/12 2xl:m-6 2xl:w-1/5" data-testid="specialty__card">
        <div className="bg-[#17243D] text-white rounded-t-lg shadow-xl p-6 w-full">
          <div className="h-48 rounded-t-lg flex items-center justify-center">
            
            <img
              src={dogeEnvironmentIcon}
              alt="Doge Environment Top Image"
              id="doge_environment__icon"
            />
            
          </div>
        </div>
        <div className="bottom_our_specialties__card bg-[#0C1320] text-white rounded-b-lg shadow-xl p-6 w-full">
          <div className="p-3">

            <div className="our_specialties__seperator border-b-2 mb-12" />

            <div className="w-full text-center">
              <center>
                <SubHeading
                  text="DOGE ENVIRONMENT"
                  className="text-lg sm:text-sm md:text-md text-white mb-12"
                  alt="Doge Environment Heading"
                  id="dogeEnvironmentText"
                />
              </center>
            </div>

            <p className="text-gray-400 text-lg" data-testid="doge_environment__description">
              Dogechain is a proof-of-stake (PoS) blockchain that runs on the Polygon network, which is
              Ethereum's largest sidechain. Dogechain supports apps and games developed for Ethereum. The
              $DC token is the official token of the project, it has been airdropped to users and they can
              stake their $DC tokens and earn a passive income stream.
              <br/><br/><br/>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
 
export default DogeEnvironment;